<template>
    <div class="vote-view-wrapper">

        <div class="logo-vote">
            <div class="block-bg"></div>
            <img src="@/assets/logo_vote.png"/>
        </div>

        <div class="vote-view" v-if="loaded.desc">
            <!--Into text-->
            <div class="intro-text" v-if="state === 0" v-html="description">

            </div>

            <!-- Email form-->
            <div v-if="state === 0">
                <label><b>Please enter your email to vote:</b></label><br>
                <div class="form-tmp-row">
                    <input type="text" autofocus v-model="email" @keyup.enter="checkMail" />
                    <button :disabled="!email" @click="checkMail">Continue</button>
                </div>
            </div>

            <!-- Vote form-->
            <div v-if="state === 1">
                <div v-if="loaded.options">
                    <b v-if="category === options.length">Please select your nominations and press 'submit votes' at the bottom of the page.</b>
                    <b v-else>Please select your nominations and press 'next' at the bottom of the page.</b>
                    <br>
                    <!-- selectors -->
                    <div v-for="(name, idx) in optionKeys" :key="name" v-show="idx === category">
                        <h2>{{name}}</h2>
                        <div v-for="nom in options[name]" class="vote-option-wrapper" :key="nom.pk">
                            <div class="radio-vote-btn">
                                <span><input type="radio" v-model="votes[name]" :value="nom.pk" /></span>
                            </div>
                            <div class="vote-btn-text">
                                <span class="fixwidth">Author:</span>    <span>{{nom.name}}</span><br>
                                <span class="fixwidth" v-if="nom.paper">Document:</span><span class="margin-l" v-if="nom.paper">
                                  <a :href="nom.paper" target="_blank"><template v-if="nom.title">{{nom.title}}</template><template v-else>Download</template></a>
                                </span><br>
                                <span class="fixwidth" v-if="nom.desc" >Description:</span><br>
                                <span style="float:clear; overflow:hidden;" v-html="nom.desc" v-if="nom.desc" ></span>
                            </div>
                        </div>

                        <!-- no preference -->
                        <div class="vote-option-wrapper">
                            <div class="radio-vote-btn">
                                <span><input type="radio" v-model="votes[name]" :value="undefined" /></span>
                            </div>
                            <div class="vote-btn-text">
                                <span style="font-weight: bold">No preference for this category</span>
                            </div>
                        </div>

                        <!-- submit button -->
                        <div class="submit-wrapper">
                          <button v-if="category > 0" :disabled="category < 1" class="submit-btn" @click="category--">Previous</button>
                          <button v-if="(category + 1) < optionKeys.length" :disabled="!canProceed(name)" class="submit-btn" @click="category++">Next</button>
                          <button v-else :disabled="!completed" class="submit-btn" @click="doSubmit()">Submit</button>
                        </div>
                    </div>
                </div>

                <!--Loading msg-->
                <div v-else>
                    <b>We are loading the voting options, please wait...</b>
                </div>
            </div>

            <!-- Vote done-->
            <div v-if="state === 2">
                <b>Thank you for voting! You may now close this page.</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "v-vote",
  data() {
    return {
      email: "",
      state: 0,
      category: 0,
      options: null,
      votes: null,
      loaded: { options: false, desc: false },
      description: null,
    };
  },
  computed: {
    completed: function () {
      for (var item in this.votes) {
        if (this.votes[item] === null) return false;
      }
      return true;
    },
    optionKeys: function () {
      if (!this.options) return [];
      return Object.keys(this.options);
    },
  },
  methods: {
    errorHandler(error) {
      if (error.response.data.error) {
        alert(error.response.data.error);
      } else {
        alert("Unknown error occured");
        console.log({ error });
      }
    },
    canProceed(category) {
      return this.votes[category] !== null;
    },
    doSubmit() {
      var ctx = this;
      this.axios
        .post("/voting/vote", {
          email: this.email,
          votes: this.votes,
        })
        .then(function (response) {
          ctx.state = 2;
        })
        .catch(this.errorHandler);
    },
    checkMail() {
      var ctx = this;
      this.axios
        .post("/voting/check", { email: this.email })
        .then(function (response) {
          ctx.state = 1;
        })
        .catch(this.errorHandler);
    },
  },
  mounted() {
    var ctx = this;
    this.axios
      .get("/voting/description", {})
      .then(function (response) {
        ctx.$set(ctx, "description", response.data.description);
        ctx.$set(ctx.loaded, "desc", true);
      })
      .catch(this.errorHandler);
    this.axios
      .get("/voting/options", {})
      .then(function (response) {
        var votes = {};
        var categories = Object.keys(response.data);
        for (var name in categories) {
          votes[categories[name]] = null;
        }
        ctx.$set(ctx, "votes", votes);
        ctx.$set(ctx, "options", response.data);
        ctx.$set(ctx.loaded, "options", true);
      })
      .catch(this.errorHandler);
  },
};
</script>

<style lang="scss">
.vote-option-wrapper {
  display: flex;
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid #bebebe;
  .radio-vote-btn {
    span {
      input {
        height: 100%;
        margin: 0 20px;
      }
    }
  }
  .vote-btn-text {
    width: 100%;
    > span {
      float: left;
      &.fixwidth {
        width: 120px;
        font-weight: bold;
      }
    }
  }
}
.submit-wrapper {
  display: flex;
  .submit-btn {
    width: 100%;
    height: 30px;
  }
}
.app-wrapper {
  margin: 0 !important;
  padding: 0 !important;
}
.logo-vote {
  width: 100%;
  height: 120px;
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  img {
    height: 120px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
  }
  .block-bg {
    height: 120px;
    width: 100%;
    position: absolute;
    top: 43px;
    background: #009cb4;
    z-index: 50;
  }
}

.vote-view-wrapper {
  font-family: "Trebuchet MS", Helvetica, sans-serif;
  .intro-text {
    span {
      display: block;
      margin: 10px 0;
    }
  }
  .vote-view {
    padding: 20px;
    border: 1px solid #bebebe;
    margin: 0 auto;
    max-width: 500px;
    .form-tmp-row {
      display: flex;
      width: 100%;
      input {
        flex-grow: 1;
      }
    }

    .bottom-border-tr {
      border-bottom: 1px solid #bebebe !important;
      display: block;
      td {
        padding: 0 5px;
      }
    }
  }
}
</style>
